import Marquee from "react-fast-marquee";

const WORDS = [
  "Sandalwood Heartwood",
  "Kashmir Kesar",
  "Pure Distilled Oil",
  "Iranian Saffron",
  "Aged Since 1911",
  "Stone-Milled Powder",
];

export const EditorialMarquee = () => {
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-[#2C2621] py-6 bg-[#1A1714]"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span
            key={i}
            className="font-sans-lux text-sm uppercase tracking-[0.25em] text-[#D49A44] mx-10 inline-flex items-center gap-10"
          >
            {w}
            <span className="text-[#7C756B]">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
